import { Injectable } from '@angular/core';
import { CvdChartData, CvdChartDataValue } from '@covance/ng-cvd3';
import { LabTestResult } from '../lab-test-results';
import { chain, groupBy, map, orderBy } from 'lodash';
import { getShapeByGender, getColorByGender, getSexLabelByShape } from './chart-helper';

@Injectable()
export class BoxplotChartDataBuilder {
    constructor() { }

    public buildChartData(
        results: LabTestResult[], 
        showSplitGenders: boolean, 
        groupKeySelector: (result: LabTestResult) => string,
        xAxisTickRenderer: (groupKey: string, data: LabTestResult[]) => string,
        xAxisSorting: (results: LabTestResult[]) => number | string) {

        const groupKeys = chain(results)
                .uniqBy(groupKeySelector)
                .map(groupKeySelector)
                .value();

        if (results === null) {
            return null;
        }
        const validData = results.filter(d => !d.isCancelled);
        const dataSource = showSplitGenders 
            ? groupBy(validData, test => getSexLabelByShape(getShapeByGender(test.sex))) 
            : {'All Genders': validData};

        const dataByGender = map(dataSource, (genderData, gender) => {
            const byVisits = chain(genderData)
                .groupBy(groupKeySelector).value();

            const visitData = chain(groupKeys)
                .filter(groupKey => !!groupKey)
                .map(groupKey => {
                    const yValues = byVisits[groupKey] || [];
                    const x = xAxisTickRenderer(groupKey, validData);
                    const sortKey = xAxisSorting ? xAxisSorting(yValues) : x;

                    return {
                        x: x,
                        y: yValues.map(test => ({
                            y: test.currentResult.numericResult,
                            rowId: test.labTestId,
                            shape: getShapeByGender(test.sex)
                        })),
                        rows: [sortKey],
                        series: 0
                    } as CvdChartDataValue;
                })
                .sortBy(value => value.rows[0])
                .value();

            const data: CvdChartData<CvdChartDataValue> = {
                key: gender,
                rows: [],
                color: getColorByGender(gender),
                values: visitData
            };
            return data;
        });
        return orderBy(dataByGender, (d: CvdChartData<CvdChartDataValue>) => d.key);
    }
}